import { api } from "@/App";

const CHUNK_FALLBACK = 3 * 1024 * 1024;

/** Carica un video a chunk (qualsiasi dimensione) e ritorna l'upload_id lato server. */
export async function uploadVideoChunks(file, { kind = "story", onProgress } = {}) {
  const ext = (file.name?.split(".").pop() || "mp4").toLowerCase();
  const init = await api.post("/media/video/init", { size: file.size, ext, kind });
  const { upload_id, chunk_size } = init.data;
  const size = chunk_size || CHUNK_FALLBACK;
  const total = Math.ceil(file.size / size);
  for (let i = 0; i < total; i++) {
    const form = new FormData();
    form.append("upload_id", upload_id);
    form.append("index", String(i));
    form.append("chunk", file.slice(i * size, (i + 1) * size), `part_${i}`);
    await api.post("/media/video/chunk", form, { headers: { "Content-Type": "multipart/form-data" } });
    onProgress?.((i + 1) / total);
  }
  return upload_id;
}

/** Segue un job di elaborazione media fino al completamento. */
export async function waitForJob(jobId, onProgress) {
  for (let i = 0; i < 300; i++) {
    await new Promise((r) => setTimeout(r, 1200));
    const { data } = await api.get(`/media/job/${jobId}`);
    onProgress?.((data.progress || 0) / 100, data.phase);
    if (data.status === "done") return data.result || {};
    if (data.status === "error") throw new Error(data.error || "Elaborazione non riuscita");
  }
  throw new Error("Elaborazione troppo lunga, riprova");
}
